import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SensorSelectModalComponent } from './sensor-select-modal.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  declarations: [SensorSelectModalComponent],
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatSelectModule,
    FormsModule,
    MatDialogModule,
    MatButtonModule,
  ],
  exports: [SensorSelectModalComponent],
})
export class SensorSelectModalModule {}
